import { OptionItemSelector } from '@/src/app/main/(tabs)/card/card-management/payment/optionItemSelector'
import { PaymentCardInformation } from '@/src/app/main/(tabs)/card/card-management/_common/paymentCardInformation'
import { CardPaymentsStore as Store } from '@/src/experiences/card-payments/store'
import { formatCurrency } from '@/src/common/utils/general'
import { formatDate } from '@/src/common/utils/date'

export function PaymentConfirmation({ cardInformationTitle }: { cardInformationTitle?: string }) {
  const { paymentAmount, paymentType, paymentDate, paymentDateType, account } =
    Store.useOneTimePayment()
  const parsedAmount = paymentAmount ? formatCurrency(paymentAmount) : ''
  const paymentDateString = paymentDate ? formatDate(new Date(paymentDate)) : ''

  // king: make component
  return (
    <PaymentCardInformation
      title={cardInformationTitle}
      containerStyle={{ marginHorizontal: 16, position: 'relative' }}
    >
      <OptionItemSelector label="Amount" title={parsedAmount} subtitle={paymentType} />
      <OptionItemSelector label="Date" title={paymentDateString} subtitle={paymentDateType} />
      <OptionItemSelector label="Bank Account" title={account?.last4} withBorder={false} />
    </PaymentCardInformation>
  )
}
